import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';

const endpoints = {
	updateCookies: () => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/user/legal/cookies_message/true`,
		method: API_METHODS.PATCH,
	}),
};

export const updateCookies = async () =>
	axiosRequest(endpoints.updateCookies());
